import { render, staticRenderFns } from "./Costs.vue?vue&type=template&id=717d5c4e&"
import script from "./Costs.vue?vue&type=script&lang=ts&"
export * from "./Costs.vue?vue&type=script&lang=ts&"
import style0 from "./Costs.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports